<div class="error-container flex flex-column flex-align-center flex-justify-center p-2xl gap-lg">
  <div class="error-icon text-5xl">⚠️</div>

  <h1 class="text-2xl font-semibold">Something Went Wrong</h1>

  <p class="error-message text-center" [innerHTML]="errorMessage"></p>

  @if (errorType === 'opfs-lock') {
  <ol class="help-steps text-sm" style="text-align:left; padding-left: 1.5rem; line-height: 1.8">
    <li>Close all other tabs or windows for this app</li>
    <li>Click <strong>Reload Page</strong> below</li>
  </ol>
  }

  <div class="actions flex flex-column gap-md">
    @if (showReloadButton) {
    <button class="btn btn-primary" (click)="reloadPage()" type="button" data-testid="reload-button">
      Reload Page
    </button>
    } @else {
    <button class="btn btn-primary" (click)="resetAndRestart()" type="button" data-testid="reset-button">
      Reset and Restart
    </button>
    }

    <button class="btn btn-secondary" (click)="goToLanding()" type="button" data-testid="go-to-landing-button">
      Go to Landing Page
    </button>
  </div>

  <p class="help-text text-sm">
    If the problem persists, please contact support.
  </p>
</div>